export const SENDING_STATUTES = {
    CREATED: 1,
    CIPHERING: 2,
    READY: 3,
};

export const REVERSED_SENDING_STATUTES = [undefined, ...Object.keys(SENDING_STATUTES).map(key => key)]